import React from "react";

const BizKimiz = () => {
    return (
        <section
            className="relative min-h-screen w-full bg-cover bg-center text-white"
            id="hakkimizda"
            style={{ backgroundImage: "url('images/about.png')" }} // ↓ buraya görselin yolunu koy
        >
            {/* Koyu Overlay */}
            <div className="absolute inset-0 bg-stone-900/70"></div>

            {/* İçerik */}
            <div className="relative max-w-6xl mx-auto px-6 py-20 text-center leading-relaxed">
                <h2 className="text-3xl font-bold mb-8 tracking-wider">
                    BİZ KİMİZ?
                </h2>

                <p className="text-lg mb-6">
                    1976 yılında Nejdet Kahraman tarafından kurulan Kahraman Ahşap Merdiven,
                    ahşap ustalığının inceliklerini modern tasarım anlayışıyla buluşturarak
                    İzmir ve çevresine hizmet vermeye başlamıştır. Ahşap işçiliğinde yarım
                    asrı aşkın birikimiyle sektörün öncüsü haline gelen firmamız, 1997 yılında
                    Nejdet Kahraman’ın değerli çırağı Nevzat Tekin tarafından devralınmıştır.
                </p>

                <p className="text-lg mb-6">
                    Nevzat Tekin’in liderliğinde, geleneksel ahşap işçiliğini yenilikçi
                    çözümlerle birleştiren firmamız, İzmir Karabağlar’daki atölyemizde,
                    ahşap merdiven, kapı, küpeşte, pergola, deck ve cephe kaplama gibi birçok
                    alanda uzmanlaşmıştır. Kaliteye ve müşteri memnuniyetine verdiğimiz önemle,
                    her projeyi titizlikle ele alarak dayanıklılığı estetikle birleştiren
                    çözümler sunuyoruz.
                </p>

                <p className="text-lg mb-14">
                    Kahraman Ahşap Merdiven olarak, ahşaba duyduğumuz sevgiyi her detayda
                    hissettiren işler üretmeye devam ediyoruz. Sizin için de özel çözümler
                    sunmaya hazırız.
                </p>

                {/* Kartlar */}
                <div className="grid md:grid-cols-3 gap-12 mt-10">
                    {/* Kart 1 */}
                    <div>
                        <h3 className="text-lg font-bold mb-4 tracking-wider">
                            NEDEN KAHRAMAN AHŞAP MERDİVEN?
                        </h3>
                        <p className="text-sm text-gray-300">
                            Geleneksel ustalıkla modern tasarım anlayışını bir araya getirerek
                            estetik ve dayanıklılığı ön planda tutan çözümler sunuyoruz.
                            Her proje bizim için bir sanat eseri!
                        </p>
                    </div>

                    {/* Kart 2 */}
                    <div>
                        <h3 className="text-lg font-bold mb-4 tracking-wider">
                            GENİŞ HİZMET YELPAZESİ
                        </h3>
                        <p className="text-sm text-gray-300">
                            Ahşap merdivenden kapıya, pergoladan cephe kaplamaya kadar birçok
                            alanda uzmanız. Hayallerinizi gerçekleştirecek özelleştirilmiş
                            ahşap çözümler sunuyoruz.
                        </p>
                    </div>

                    {/* Kart 3 */}
                    <div>
                        <h3 className="text-lg font-bold mb-4 tracking-wider">
                            YARIM ASIRLIK GÜVEN VE DENEYİM
                        </h3>
                        <p className="text-sm text-gray-300">
                            1976’dan bugüne uzanan tecrübemizle, ahşap işçiliğinde kalite ve
                            güvenin adresiyiz. Ustalığımızla evlerinize ve iş yerlerinize
                            değer katıyoruz.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BizKimiz;
